import { HttpClient, HttpHeaders, HttpXsrfTokenExtractor } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { setDefaultLanguage } from 'src/app/akita/multilingual/multilingual.model';
import { SubprojectQuery } from 'src/app/akita/subproject/state/subprojects.query';
import { DocumentsService } from 'src/app/core/service/api/documents.service';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-generic-upload-picture-modal',
  templateUrl: './generic-upload-picture-modal.component.html',
  styleUrl: './generic-upload-picture-modal.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericUploadPictureModalComponent {
  description: any;
  uploadFileData: any;
  selectedFileName: string | null = null;
  selectedFile: File | null = null;
  
  constructor(
    private dialogRef: MatDialogRef<GenericUploadPictureModalComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: { file: File },
    private xsrfTokenExtractor: HttpXsrfTokenExtractor,
    private globals: Globals,
    private router: Router,
    private subProjectQuery: SubprojectQuery,
    private documentsService: DocumentsService
  ){
    // avoid empty constructor
  }

  ngOnInit(): void {
    if (this.data?.file) {
      this.selectedFile = this.data.file;
      this.selectedFileName = this.data.file.name;
      this.uploadFile(this.data.file);
    }
  }

  uploadFile(file: File) {
    const formData = new FormData();
    formData.append('files[]', file);

    let headers;
    const sessionToken = localStorage.getItem('session_token');
    if(this.router.url.includes('sub')){
      const activeSubProject = this.subProjectQuery.getActive();
      const headersObj: any = {
        'X-XSRF-TOKEN': this.xsrfTokenExtractor.getToken() || '',
        'X-Project': this.globals.projectCode,
        'X-Subproject': activeSubProject.id.toString(),
        'X-Lang': setDefaultLanguage(this.globals, 'user'),
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      };
      if (sessionToken) {
        headersObj['X-Session-Token'] = sessionToken;
      }
      headers = new HttpHeaders(headersObj);
    } else {
      const headersObj: any = {
        'X-XSRF-TOKEN': this.xsrfTokenExtractor.getToken() || '',
        'X-Project': this.globals.projectCode,
        'X-Lang': setDefaultLanguage(this.globals, 'user'),
        'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
      };
      if (sessionToken) {
        headersObj['X-Session-Token'] = sessionToken;
      }
      headers = new HttpHeaders(headersObj);
    }

    this.documentsService.uploadDocument(formData, headers).subscribe((res)=>{
      this.uploadFileData = res;
    })
  }

  close(){
    this.dialogRef.close();
  }

  triggerFileInput() {
    const input = document.getElementById('fileInput') as HTMLInputElement;
    input?.click();
  }

  onFileSelected(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];
      // ✅ Only allow images
      if (file.type.startsWith('image/')) {
        this.selectedFile = file;
        this.selectedFileName = file.name;
        this.uploadFile(file);
      } else {
        alert('Please select an image file.');
        fileInput.value = '';
      }
    }
  }

  removeFile() {
    this.selectedFile = null;
    this.selectedFileName = null;
    const input = document.getElementById('fileInput') as HTMLInputElement;
    if (input) input.value = '';
  }

  onSaveComment(){
    this.dialogRef.close({msg: {file: this.selectedFile, description: this.description}, fileUploadData: this.uploadFileData[0]} as any);
  }
}
